<template>
<div class="house-select">
  <strong :style="{ color: getColor }">{{ title }} Significator</strong>
  <select v-model="houseSelect">
    <option value="1">I ({{ figureInHouse(1) }})</option>
    <option value="2">II ({{ figureInHouse(2) }})</option>
    <option value="3">III ({{ figureInHouse(3) }})</option>
    <option value="4">IV ({{ figureInHouse(4) }})</option>
    <option value="5">V ({{ figureInHouse(5) }})</option>
    <option value="6">VI ({{ figureInHouse(6) }})</option>
    <option value="7">VII ({{ figureInHouse(7) }})</option>
    <option value="8">VIII ({{ figureInHouse(8) }})</option>
    <option value="9">IX ({{ figureInHouse(9) }})</option>
    <option value="10">X ({{ figureInHouse(10) }})</option>
    <option value="11">XI ({{ figureInHouse(11) }})</option>
    <option value="12">XII ({{ figureInHouse(12) }})</option>
  </select>
</div>
</template>

<script>
import Names from '../utils/names'

export default {
  name: 'HouseSelect',
  props: {
    querent: Boolean
  },
  methods: {
    figureInHouse(ind) {
      return Names.getNameForFigure(this.$store.getters.getFigureById(ind))
    },
  },
  computed: {
    getColor () {
      if (this.querent) {
        return this.$store.getters.getTheme.primary
      } else {
        return this.$store.getters.getTheme.secondary
      }
    },
    title() {
      if (this.querent) {
        return "Querent"
      } else {
        return "Quesited"
      }
    },
    houseSelect: {
      get() {
        if (this.querent) {
          return this.$store.state.querentHouse
        } else {
          return this.$store.state.quesitedHouse
        }
      },
      set(value) {
        this.$store.commit({type: 'setTargetHouse', querent: this.querent, house: value})
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.house-select {
  display: flex;
  justify-content: space-between;
}
</style>